import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withEDSContext } from '../../EDSContext/EDSContext';
import ActionIconButton from './ActionMenuIconButton';
import decorateActionMenuChildren from './decorateActionMenuChildren';
import DrawerWrapper from '../../DrawerWrapper/DrawerWrapper';
import MenuList from '@material-ui/core/MenuList';
import { default as withStyles } from '../../styles';
import MoreVertical from '@ellucian/ds-icons/lib/MoreVertical';
import { borderRadiusXSmall } from '../../styles/tokens';
export var styles = function styles(theme) {
  return {
    root: {
      display: 'inline-block'
    },
    menuList: {
      borderRadius: borderRadiusXSmall
    }
  };
};
/**
 * `MobileActionMenu` to be rendered only on mobile platforms.
 */

var MobileActionMenu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MobileActionMenu, _React$Component);

  function MobileActionMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleToggle = function () {
      _this.setState({
        open: !_this.state.open
      });
    };

    _this.handleClose = function (event) {
      _this.setState({
        open: false
      });

      _this.focusActionMenuButton();
    };

    _this.focusActionMenuButton = function () {
      _this.buttonRef.current.focus();
    };

    _this.buttonRef = /*#__PURE__*/React.createRef();
    _this.state = {
      open: props.initialOpenOverride // action menu is closed by default, unless an override is passed in

    };
    return _this;
  }

  var _proto = MobileActionMenu.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        classes = _this$props.classes,
        id = _this$props.id,
        edsContext = _this$props.edsContext,
        icon = _this$props.icon,
        className = _this$props.className,
        IconButtonProps = _this$props.IconButtonProps,
        PaperProps = _this$props.PaperProps,
        DrawerProps = _this$props.DrawerProps,
        children = _this$props.children,
        title = _this$props.title;
    var open = this.state.open;
    var root = classes.root;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(root, className)
    }, /*#__PURE__*/React.createElement(ActionIconButton, {
      id: id,
      edsContext: edsContext,
      icon: icon,
      IconButtonProps: IconButtonProps,
      open: open,
      setOpen: this.handleToggle,
      buttonRef: this.buttonRef
    }), /*#__PURE__*/React.createElement(DrawerWrapper, {
      title: title,
      id: id,
      PaperProps: PaperProps,
      DrawerProps: DrawerProps,
      open: open,
      handleClose: this.handleClose
    }, /*#__PURE__*/React.createElement(MenuList, {
      id: id,
      className: classes.menuList
    }, decorateActionMenuChildren(children, this.handleClose))));
  };

  return MobileActionMenu;
}(React.Component);

MobileActionMenu.propTypes = {
  /**
   * @ignore
   *
   * Classes used to extend original style object.
   */
  classes: PropTypes.object,

  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,

  /**
   * A CSS class that will be applied to the parent `div`.
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  edsContext: PropTypes.object,

  /**
   * Menu HTML ID for uniqueness.
   */
  id: PropTypes.string,

  /**
   * Props applied to the `Paper` component
  */
  PaperProps: PropTypes.object,

  /**
   * @ignore
   *
   * Externally set the initial open state of the action menu. For testing purposes only.
   */
  initialOpenOverride: PropTypes.bool,

  /**
   * Props applied to the IconButton that brings up the action menu
  */
  IconButtonProps: PropTypes.object,

  /**
   * Icon used in the icon button.
   *
   * Defaults to 'more-vertical' icon.
   */
  icon: PropTypes.node,

  /**
   * Title of the action menu for mobile variant
   */
  title: PropTypes.string,

  /**
   * Props applied to the `Drawer` element.
   */
  DrawerProps: PropTypes.object
};
MobileActionMenu.defaultProps = {
  initialOpenOverride: false,
  icon: /*#__PURE__*/React.createElement(MoreVertical, null)
};
export default withEDSContext(withStyles(styles)(MobileActionMenu));